package com.evoapps.evoshift.salesimport

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import com.evoapps.evoshift.spreadsheet.SpreadsheetFilePicker
import com.evoapps.evoshift.spreadsheet.rememberSpreadsheetFilePicker
import com.evoapps.evoshift.viewmodels.PickedSalesFile

/**
 * SH-123: the file chooser for a sales export (.csv, .xlsx, .txt): the shared
 * [SpreadsheetFilePicker] (SH-214) handing over a [PickedSalesFile].
 */
typealias SalesFilePicker = SpreadsheetFilePicker

/** Called with the picked file, or with null when it could not be read. */
typealias OnSalesFilePicked = (PickedSalesFile?) -> Unit

/** Replaces the platform chooser where there is no system UI (UI tests). */
val LocalSalesFilePickerOverride = staticCompositionLocalOf<((OnSalesFilePicked) -> SalesFilePicker)?> { null }

@Composable
fun rememberSalesFilePicker(onPicked: OnSalesFilePicked): SalesFilePicker {
    val override = LocalSalesFilePickerOverride.current
    return override?.invoke(onPicked) ?: rememberSpreadsheetFilePicker { file -> onPicked(file?.let { PickedSalesFile(it.name, it.bytes) }) }
}
